import React from "react";

import Str from "shared/components/Str";
import Strf from "shared/components/Strf";
import ScamWarning from "shared/util/ScamWarning";

// Show this when we have a scam warning.
const ScamBannerMessage = () => (
	<Strf vars={{
		warning: (
			<span role="img" aria-label="Warning">⚠️</span>
		),
		moreInfoCTA: (
			<button className="banner-link" onClick={() => ScamWarning.open()}>
				<Str>More Info</Str>
			</button>
		),
	}}>
		$warning Never transfer funds to someone you met on the internet. $moreInfoCTA
	</Strf>
);

export default ScamBannerMessage;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Banners/ScamBanner.jsx